module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "frontback"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Prologue: "), _c('a', {
    attrs: {
      "href": "#/Text/Prologue"
    }
  }, [_vm._v("The Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("PART I: "), _c('a', {
    attrs: {
      "href": "#/Text/I"
    }
  }, [_vm._v("Misdirection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/Text/1"
    }
  }, [_vm._v("There is no consensus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("2. "), _c('span', {
    attrs: {
      "href": "#/Text/2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s a conspiracy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("PART II: "), _c('span', {
    attrs: {
      "href": "#/Text/II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Don’t Need to Worry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("3. "), _c('span', {
    attrs: {
      "href": "#/Text/3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who says climate change is such a bad thing?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("4. "), _c('span', {
    attrs: {
      "href": "#/Text/4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We’re heading toward an Ice Age, so why worry about warming?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("5. "), _c('span', {
    attrs: {
      "href": "#/Text/5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s no link between warming and extreme weather")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("PART III: "), _c('span', {
    attrs: {
      "href": "#/Text/III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climate Change Isn’t Happening")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("6. "), _c('span', {
    attrs: {
      "href": "#/Text/6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feels pretty cold . . . where’s your global warming?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/Text/7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The planet isn’t getting warmer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/Text/8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glaciers are growing, Antarctica is gaining ice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/Text/9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climate is too complex to model or predict")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("PART IV: "), _c('span', {
    attrs: {
      "href": "#/Text/IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s Not Our Fault")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/Text/10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There is no link between carbon dioxide and global temperature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/Text/11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s just a natural cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/Text/12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More carbon dioxide won’t make a difference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/Text/13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What about . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("PART 5: "), _c('span', {
    attrs: {
      "href": "#/Text/V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s Nothing We Can Do About It")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/Text/14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carbon taxes or cap-and-trade systems will destroy the economy, kill jobs, and hurt the poor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/Text/15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Renewable energy is too expensive or too variable")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("Epilogue: "), _c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outlook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Endnotes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Authors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa8cef8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 69
// module chunks = 0